import store from "../../../../../store";
import { DomainRegistry } from "../../../../../domain";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { TimeMeasure } from "../../../../../utilities";
import { ITreeSource } from "./ITreeSource";
import { IConfiguration } from "../../../../../domain/configuration";

export class FormatTreeSource implements ITreeSource<FormatReference> {
  constructor(private _shouldIgnoreChained: boolean, private _shouldIncludeReferenceableGroupFormats: boolean) {
  }

  private readonly config = store.getters.configuration as IConfiguration;
  entityName: string = this.config.wording.format.name + "情報";

  getTree(): Promise<Directory<string, FormatReference>[]> {
    return TimeMeasure.logAsync(
      "Tree取得",
      async () => {
        const repository = DomainRegistry.format.getFormatRepository();
        return repository.getFormats(this._shouldIgnoreChained, this._shouldIncludeReferenceableGroupFormats);
      },
      "",
      TimeMeasure.debug
    );
  }

  get managementKey(): string {
    return null;
  }
}
